import { useState, useEffect } from 'preact/hooks'
import classNames from 'classnames'
import api from 'libs/api'
import styles from 'components/styles/confirmation'
import { gaPageView } from 'libs/gaPageView'

const ResendEmail = () => {
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [disabled, setDisabled] = useState(false)

  useEffect(() => gaPageView(), [])

  const onSubmit = e => {
    e.preventDefault()
    setDisabled(true)

    api
      .resendEmail(email)
      .then(res => res.json())
      .then(response => {
        if (response.status === 200) {
          setDisabled(false)
          setMessage(response.reason)
          setMessageType('success')
        } else {
          setDisabled(false)
          setMessage(response.reason)
          setMessageType('alert')
        }
      })
  }

  const onChange = e => {
    setEmail(e.target.value)
  }

  const messageClasses = classNames(styles['resend-message'], {
    [styles['resend-message--success']]: messageType === 'success',
    [styles['resend-message--alert']]: messageType === 'alert',
  })

  return (
    <div className={styles['resend-container']}>
      <div className={styles['confirmation-text']}>
        Didn't received the email? Check your Spam/Junk/Bulk Mail folder. If you still
        can't find it, resend the email.
      </div>
      <form className={styles['resend-form']} onSubmit={onSubmit}>
        {message && <div className={messageClasses}>{message}</div>}
        <div className={styles['resend-form-control']}>
          <input
            type="text"
            value={email}
            placeholder="Email address"
            onChange={onChange}
          />
        </div>
        <button type="submit" disabled={disabled} className={styles['resend-btn']}>
          Resend My Email
        </button>
      </form>
    </div>
  )
}

export default ResendEmail
